export const FETCH_POSTOFFICES_PENDING = 'FETCH_POST_OFFICES_PENDING';
export const FETCH_POSTOFFICES_FULFILLED = 'FETCH_POST_OFFICES_FULFILLED';
export const FETCH_POSTOFFICES_FAILED = 'FETCH_POST_OFFICES_FAILED';
